module.exports = __webpack_public_path__ + "static/000588-315cdcdd2d0b02ccabd2722fc895736f.jpg";